import React from 'react'
import { Dropdown } from 'semantic-ui-react'

const ActionButton = ({ data, handleEditAction, showEdit, showDelete, handleDelete }) => {
  return (
    <Dropdown
      icon="far fa-ellipsis-vertical"
      floating
      pointing="top right"
      className="table-elipsis-toolbar-dropdown"
    >
      <Dropdown.Menu>
        <React.Fragment>
          <React.Fragment>
            {showEdit && (
              <Dropdown.Item text="Edit" icon="far fa-edit" onClick={() => handleEditAction(data)} />
            )}

            {showDelete && (
              <Dropdown.Item
                className="!text-negative"
                text="Delete"
                icon="far fa-trash-can"
                onClick={() => handleDelete(data)}
              />
            )}
          </React.Fragment>
        </React.Fragment>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default ActionButton



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Topics/ActionButton.js